import { PaymentMethodsResponse } from '@ads-bread/shared/bread/codecs';
import { APIFetch, APIResponse } from '../hooks/apiFetch';
import { HandlerResponse, handleResponse } from './base';

export const GET_PAYMENT_METHOD_URI = '/api/payments/payment-method';

export const getPaymentMethods = async function (
  apiFetch: APIFetch,
  buyerId: string
): Promise<HandlerResponse<PaymentMethodsResponse>> {
  const res: APIResponse<PaymentMethodsResponse> =
    await apiFetch<PaymentMethodsResponse>(
      `${GET_PAYMENT_METHOD_URI}?scopeID.eq=${buyerId}&scopeType.eq=BUYER`,
      { method: 'GET' },
      PaymentMethodsResponse
    );

  const validatedResponse = handleResponse(res);

  if (validatedResponse.error) {
    throw validatedResponse.error;
  }

  return {
    error: null,
    result: validatedResponse.result,
  };
};
